module.exports = __webpack_public_path__ + "img/ldr-logo.82955a90.png";